import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const addPartyNotification = (id,notification_reminder, notification_type, notification_days, to_email,enable) => {
  return axios.post(API + "parties/add-notification/"+id+"/", {
    notification_reminder,
    notification_type,
    notification_days,
    to_email,
    enable,
  },{headers: authHeader(),});
};
const AddPartyNotificationService = {
    addPartyNotification,
  };
  export default AddPartyNotificationService;